import React, { Component } from 'react';
import { getTranslate }     from 'react-localize-redux';
import { connect }          from 'react-redux';
import moment               from 'moment';
import storageHelper        from 'helpers/storage.helper';
import './index.css';

class MailHasBeenSent extends Component {

  componentDidMount() {
    storageHelper.destroyStorage();
  }

  render() {
    const { translate } = this.props;

    return (
      <div className="sent-box">
        <div className="sent-box--content">
          <div>
            <div className="sent-box--logo" />
            <div className="sent-box--header">
              <div className="sent-icon" />
              <span>{ translate('common.sent.check') }</span>
            </div>
            <div className="sent-box--body">
              <div className="sent-header" >{ translate('common.sent.recently') }</div>
              <div className="sent-cont">{ translate('common.sent.text') }</div>
            </div>
            <div className="sent-box--footer">
              <div className="sent-foot-text" >
                { translate('common.sent.mail') }
                <a href={`mailto:${translate('common.header.email')}`}>
                  { translate('common.header.email') }
                </a>
              </div>
            </div>
          </div>
          <div className="deleted-box--footer">
            { translate('common.footer_notice', { year: moment().year() }) }
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  translate: getTranslate(state.locale)
});
export default connect(mapStateToProps)(MailHasBeenSent);



// WEBPACK FOOTER //
// ./src/components/common/mailHasBeenSent/mailHasBeenSent.js